// Отдельный модуль без HTTP/React: auth middleware не замыкает цикл store → HTTP → store.
const listeners = new Set<(authenticated: boolean) => void>();

export function subscribeAvatarSession(listener: (authenticated: boolean) => void): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}

export function resetAvatarSession(authenticated = false): void {
    listeners.forEach((listener) => listener(authenticated));
}
